<template>
    <svg
        t="1653619483348"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="1261"
        :width="size"
        :height="size"
    >
        <path
            d="M902.2 334.6H803c-4.2-71.2-33.9-137.6-84.8-188.5C663.1 91 589.9 60.7 512 60.7c-77.9 0-151.1 30.3-206.1 85.4C255 197 225.2 263.4 221 334.6h-99.2c-19.3 0-35 15.7-35 35v558.7c0 19.3 15.7 35 35 35h780.4c19.3 0 35-15.7 35-35V369.6c0-19.3-15.7-35-35-35zM512 130.7c116.2 0 211.8 90 220.8 203.9H291.2c9-113.9 104.6-203.9 220.8-203.9z m355.2 762.6H156.8V404.6h710.4v488.7z"
            p-id="1262"
            fill="#707070"
        ></path>
        <path
            d="M472.1 627.5v145.3c0 20.3 16.4 36.7 36.7 36.7h5.8c20.3 0 36.7-16.4 36.7-36.7V624.5c29.1-15.4 49-46 49-81.2 0-50.7-41.1-91.8-91.8-91.8s-91.8 41.1-91.8 91.8c0 37.7 22.8 70.1 55.4 84.2z"
            p-id="1263"
            fill="#707070"
        ></path>
    </svg>
</template>

<script>
export default {
    props: ["size"],
};
</script>

<style>
</style>